import { DownCaretIcon } from '../assets/svgImages';
import { PanelPropInputItem, PanelProps } from '../interface/interface';
import Select, { components } from 'react-select';
import CustomDatePicker from './CustomDatePicker';

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <DownCaretIcon />
    </components.DropdownIndicator>
  );
};

// May need to move this as a helper component
const InputComponentByType = (props: PanelPropInputItem) => {
  const { type, accessor, value, onUpdate, error, isDisabled } = props;

  switch (type) {
    case 'text':
      return (
        <input
          type={type}
          name={accessor}
          id={accessor}
          className={`text-sm font-regular border rounded-md p-2 w-full ${error ? 'border-red-600' : 'border-secondary-cornflowerblue-400'}`}
          value={value as string}
          onChange={(e) => {
            onUpdate(e.target.value, accessor);
          }}
        />
      );

    case 'number':
      return (
        <input
          type={type}
          name={accessor}
          id={accessor}
          className={`text-sm font-regular border  rounded-md p-2 w-full ${error ? 'border-red-600' : 'border-secondary-cornflowerblue-400'}`}
          value={value as string}
          onChange={(e) => {
            onUpdate(e.target.value, accessor);
          }}
        />
      );

    case 'select':
      return (
        <Select
          value={value}
          options={props.options}
          name={accessor}
          onChange={(selectedOption) =>
            onUpdate(selectedOption as any, accessor)
          }
          components={{
            DropdownIndicator,
            IndicatorSeparator: () => null,
          }}
          className={error ? 'select-error' : ''}
        />
      );

    case 'date':
      return (
        <div className="relative">
          <CustomDatePicker
            value={value as Date | undefined}
            handleDate={(date) => onUpdate(date as Date, accessor)}
            className={`${error ? 'dob-error' : isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            maxDate={accessor === 'dob' ? true : false}
            isSASEnabled={isDisabled}
          />
        </div>
      );

    case 'pre-text':
      return (
        <>
          <span
            className={`inline-flex items-center rounded-l-md border border-r-0  px-3 
          text-gray-500 sm:text-sm ${error ? 'border-red-600' : 'border-secondary-cornflowerblue-400'}`}
          >
            {props.preTextContent}
          </span>
          <input
            type={type}
            name={accessor}
            id={accessor}
            className={`rounded-none rounded-r-md placeholder:text-gray-400 text-sm font-regular border  
            p-2 w-full ${error ? 'border-red-600' : 'border-secondary-cornflowerblue-400'}`}
            value={value as string}
            onChange={(e) => {
              onUpdate(e.target.value, accessor);
            }}
          />
        </>
      );

    case 'checkBox':
      return (
        <label className="flex items-center space-x-3 mb-2">
          <input
            type={type}
            name={accessor}
            id={accessor}
            className={`form-checkbox h-5 w-5 text-primary-blue-500 mt-1 ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
            checked={value as boolean}
            onChange={() => {
              onUpdate(!value, accessor);
            }}
            disabled={isDisabled}
          />
          <span
            className={`text-md text-primary-blue-500 ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
          >
            Operating Under SAS B
          </span>
        </label>
      );

    default:
      return <></>;
  }
};

export const Panel = ({ name, inputs }: PanelProps) => {
  const checkBoxInput = inputs.filter((input) => input.type === 'checkBox');
  const otherInputs = inputs.filter((input) => input.type !== 'checkBox');

  return (
    <>
      <div className="p-7 bg-secondary-pink-50 shadow rounded-xl mb-10">
        <div className="flex justify-between">
          <h3 className="mb-3 text-lg font-semibold text-primary-blue-500">
            {name}
          </h3>
          {checkBoxInput.map((input, index) => (
            <div
              key={index}
              className={`mt-2 ${input.type === 'pre-text' ? 'flex rounded-md shadow-sm' : ''}`}
            >
              <InputComponentByType {...input} />
            </div>
          ))}
        </div>
        <div className="grid  grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 px-6 py-7 bg-white rounded-md">
          {otherInputs.map((input, index) => (
            <>
              <div className="sm:col-span-2" key={index}>
                <label
                  htmlFor={input.label}
                  className="text-sm font-semibold  text-secondary-pink-700"
                >
                  {input.label}{' '}
                  {input.isRequired ? (
                    <span className="text-red-500">*</span>
                  ) : null}
                </label>
                <div
                  className={`mt-2 ${input.type === 'pre-text' ? 'flex rounded-md shadow-sm' : ''}`}
                >
                  <InputComponentByType {...input} />
                </div>
                <small className="text-red-600">{input.error}</small>
              </div>
            </>
          ))}
        </div>
      </div>
    </>
  );
};
